import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@itonics/ngx-translate-simple';
import { TimePickerComponent } from './time-picker.component';
import { TimePickerValueComponent } from './time-picker-value/time-picker-value.component';
import { TimePickerDropDownComponent } from './time-picker-drop-down/time-picker-drop-down.component';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [TimePickerComponent, TimePickerValueComponent, TimePickerDropDownComponent],
  exports: [TimePickerComponent, TimePickerValueComponent, TimePickerDropDownComponent]
})
export class TimePickerModule {}
